import * as actions from "Actions";
import * as api from "Api";
import { pushSourceToken } from "Utils";

export const fetchSurvey = () => {
  return (dispatch, getState) => {
    let sourceToken = pushSourceToken("FETCH_SURVEY", dispatch);

    const { auth } = getState();
    const { token, navCommunity, loggedAs } = auth;

    return dispatch(
      actions.fetchSurvey(
        api
          .getSurvey({
            token,
            communityId: navCommunity ? navCommunity.id : null,
            isClient: loggedAs === "CLIENT",
            sourceToken
          })
          .then(resp => {
            if (
              resp &&
              resp.data &&
              resp.data.data &&
              resp.data.data[0].latestInstance &&
              resp.data.data[0].latestInstance.id
            ) {
              dispatch(
                actions.fetchUserResponse(
                  api.getUserResponse({
                    token,
                    communityId: navCommunity ? navCommunity.id : null,
                    instanceId: resp.data.data[0].latestInstance.id
                  })
                )
              );
              if (
                resp.data.data[0].dimensions &&
                resp.data.data[0].dimensions[0].questions &&
                resp.data.data[0].dimensions[0].questions[0].id
              ) {
                dispatch(
                  actions.fetchSurveyStats(
                    api.getSurveyStats({
                      token,
                      instanceId: resp.data.data[0].latestInstance.id,
                      questionId:
                        resp.data.data[0].dimensions[0].questions[0].id
                    })
                  )
                );
              }
            }
            return resp;
          })
      )
    );
  };
};

export const fetchSurveyStats = ({ instanceId, questionId }) => {
  return (dispatch, getState) => {
    const { token } = getState().auth;

    return dispatch(
      actions.fetchSurveyStats(
        api.getSurveyStats({
          token,
          instanceId,
          questionId
        })
      )
    );
  };
};

export const setResponse = ({ choice, instanceId, questionId } = {}) => (
  dispatch,
  getState
) => {
  const { token, user, navCommunity } = getState().auth;
  return dispatch(
    actions.setResponse(
      api.sendChoice({
        token,
        instanceId,
        questionId,
        user: user.id,
        choice,
        communityId: navCommunity.id
      })
    )
  );
};



// WEBPACK FOOTER //
// ./src/actions/thunks/survey.js